// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as BrowserUtils from "../../../../library/utils/BrowserUtils.bs.js";
import * as TrackLiveTripConfig from "../../domain/store/TrackLiveTripConfig.bs.js";
import * as TrackLiveTripMarketingVMMapper from "../view-model/TrackLiveTripMarketingVMMapper.bs.js";

function showMobileApps(param) {
  var isAndroid = BrowserUtils.useAndroidDetector(undefined);
  return React.createElement("div", {
              className: "track-live-trip-marketing-simple__mobile-apps"
            }, React.createElement("div", {
                  className: "title"
                }, TrackLiveTripConfig.download_app_text), React.createElement("div", {
                  className: "apps-list"
                }, isAndroid ? React.createElement("a", {
                        className: "app",
                        href: TrackLiveTripConfig.android_link,
                        onClick: (function (param) {
                            return TrackLiveTripMarketingVMMapper.publishGAEvents("Static Download Android", "");
                          })
                      }, React.createElement("img", {
                            className: "img",
                            alt: "android icon",
                            src: TrackLiveTripConfig.android_icon
                          })) : React.createElement("a", {
                        className: "app",
                        href: TrackLiveTripConfig.ios_link,
                        onClick: (function (param) {
                            return TrackLiveTripMarketingVMMapper.publishGAEvents("Static Download iOS", "");
                          })
                      }, React.createElement("img", {
                            className: "img",
                            alt: "ios icon",
                            src: TrackLiveTripConfig.ios_icon
                          }))));
}

function TrackLiveTripMarketingComponentSimple(Props) {
  return React.createElement("div", {
              className: "track-live-trip-marketing-simple__container"
            }, showMobileApps(undefined));
}

var make = TrackLiveTripMarketingComponentSimple;

export {
  showMobileApps ,
  make ,
  
}
/* react Not a pure module */
